/** @format */
import { ProductItem } from 'src/utils/interface'
// 资源分组列表
export interface GroupItemProps {
  groupId: number
  groupName: string
  status?: number
  resourceNumber: number
  alarmTemplateNumber: number
}

// 资源分组包含的产品线
export interface GroupProductProps {
  productType: number
  productName?: string
  resourceNumber: number
  groupDynamicRules: GroupDynamicRules
  childTypes?: ProductItem[]
  resourceBindType?: 1 | 2
}

// 条件匹配
export interface GroupDynamicRules {
  productType: number
  relation: 'and' | 'or'
  filters: GroupDetailsProductFilter[]
}

// 资源分组详情 - 条件匹配方式
export enum FilterRelationMenu {
  and = '全部满足条件',
  or = '满足任意条件'
}

// 资源分组详情 - 筛选条件
export interface GroupDetailsProductFilter {
  function: 'startWith' | 'endWith' | 'contains' | 'notContains' | ''
  name: 'instanceName' | 'instanceIp' | ''
  value: string
}

export const initGroupFilter: GroupDetailsProductFilter = {
  name: '',
  function: '',
  value: ''
}
// 资源分组详情 - 筛选条件 - 匹配字段名
export enum FilterNameEnum {
  instanceName = '实例名称'
  // instanceIp = '实例信息'
}
// 资源分组详情 - 筛选条件 - 过滤规则
export enum FilterFunctionEnum {
  startWith = '前缀',
  endWith = '后缀',
  contains = '包含',
  notContains = '不包含'
}
